import { Skeleton } from "@/components/atoms/Skeleton";

const FormAddEditReviewSkeleton = () => {
  return (
    <div>
      <div className="flex flex-col gap-7">
        <div className="flex flex-col gap-2">
          <Skeleton className="w-56 h-6 rounded-xl border" />
          <Skeleton className="w-full h-8 rounded-xl border" />
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton className="w-56 h-6 rounded-xl border" />
          <Skeleton className="w-full h-52 rounded-xl border" />
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton className="w-56 h-6 rounded-xl border" />
          <Skeleton className="w-28 h-8 rounded-xl border" />
        </div>
        <div className="flex justify-end gap-2 max-sm:flex-col">
          <Skeleton className="w-20 h-10 rounded-xl border max-sm:w-full" />
          <Skeleton className="w-20 h-10 rounded-xl border max-sm:w-full" />
        </div>
      </div>
    </div>
  );
};

export default FormAddEditReviewSkeleton;
